import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@/core/api/client'

export const audioVersionService = {
	/**
	 * Get all audio versions
	 */
	getAudioVersions(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/audio_versions/adverts', config)
	},
}

export default audioVersionService
